// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"2de2fd70","357":"a247bf46"}[chunkId] + ".chunk.js";
};